import { useSearchParams } from 'react-router-dom';

type Result = {
  selectedId: string | null;
  setSelectedId: (id: string | null) => void;
};

export function useSelectedMember(): Result {
  const [params, setParams] = useSearchParams();
  const selectedId = params.get('member');
  const setSelectedId = (id: string | null): void => {
    setParams(
      (prev) => {
        const next = new globalThis.URLSearchParams(prev);
        if (id) next.set('member', id);
        else next.delete('member');
        return next;
      },
      { replace: true }
    );
  };
  return { selectedId, setSelectedId };
}
